module.exports = __webpack_public_path__ + "static/media/LiveIcon.c4620890.svg";